<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/10xDwJy/tc-custom/9780470246801.jpg?1718106412626" alt="This image is the cover for the book Project Manager's Spotlight on Risk Management"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Project Manager's Spotlight on Risk Management
      </h1>
      <p class="bookDescription body article font2">
        <p>Clear-Cut Ways to Manage Project Risk   If you're a typical project manager, you're probably aware of  the importance of risk management but may not have the time or  expertise to develop a full-blown plan. This book is a quick and  practical guide to applying the disciplines of proven risk  management practices without the rigor of complex processes.  Part of the Project Manager's Spotlight series from  Harbor Light Press, this straightforward book offers solutions to  real-life risk scenarios. Inside, best-selling author Kim Heldman  highlights critical components of risk management and equips you  with tools, techniques, checklists, and templates you can put to  use immediately. By following a realistic case study from start to  finish, you'll see how a project manager deals with each concept.  Ultimately, this book will help you anticipate, prevent, and  alleviate major project risks.  Project Manager's Spotlight on Risk Management teaches  you how to    Look for and document risk  Anticipate why projects fail  Prevent scope and schedule risks  Analyze and prioritize risks  Develop, implement, and monitor risk response plans  And much more!</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Kim Heldman
      </h2>
      
      <p class="authorDescription body article">Kim Heldman, PMP is the best selling author of Sybex's PMP Study Guide and Project Management Jumpstart. Kim is Director of IT Project Management for the Colorado Department of Revenue.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Wiley
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?cc26e79c